function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

document.addEventListener("click", function (event) {
  if (event.target.matches(".gift-wrap")) {
    const giftWrapElement = document.querySelectorAll(".gift-wrap");
    const giftWrap = event.target;
    if (giftWrap.checked) {
      giftWrapElement.forEach((e) => {
        e.checked = true;
        e.value = "True";
      });
      giftValue = true;
      setCookie("giftWrapValue", "true", 7);
    } else {
      giftWrapElement.forEach((e) => {
        e.checked = false;
        e.value = "False";
      });
      giftValue = false;
      setCookie("giftWrapValue", "false", 7);
    }
  }
});

function checkCookie() {
  const giftWrapElement = document.querySelectorAll(".gift-wrap");

  const giftWrapValue = getCookie("giftWrapValue");
  if (giftWrapValue === "true") {
    giftWrapElement.forEach((e) => {
      e.setAttribute("checked", true);
      e.value = "True";
    });
  } else if (giftWrapValue === "false") {
    giftWrapElement.forEach((e) => {
      e.removeAttribute("checked");
      e.value = "False";
    });
  } else {
  }
}
document.addEventListener("DOMContentLoaded", function () {
  checkCookie();
});

function syncTextAreas() {
  const textArea1 = document.getElementById("Cart-note");
  const textArea2 = document.getElementById("CartDrawer-Note");
  function updateTextArea1() {
    if (textArea1) {
      textArea1.value = textArea2.value;
    }
  }
  function updateTextArea2() {
    if (textArea2) {
      textArea2.value = textArea1.value;
    }
  }
  if (textArea1) {
    textArea1.addEventListener("input", updateTextArea2);
  }
  if (textArea2) {
    textArea2.addEventListener("input", updateTextArea1);
  }
}
syncTextAreas();
